import React from 'react';
import Icon from '../../../components/AppIcon';

const BulkActionsPanel = ({
  selectedCount,
  onMarkAsRead,
  onDelete,
  onCancel,
  currentLanguage
}) => {
  const translations = {
    en: {
      selected: 'selected',
      markAsRead: 'Mark as Read',
      delete: 'Delete',
      cancel: 'Cancel'
    },
    ko: {
      selected: '개 선택됨',
      markAsRead: '읽음으로 표시',
      delete: '삭제',
      cancel: '취소'
    }
  };

  const t = translations?.[currentLanguage];

  return (
    <div className="mb-4 p-4 bg-primary/10 border border-primary rounded-lg">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-2">
          <Icon name="CheckSquare" size={20} className="text-primary" />
          <span className="text-sm font-medium text-foreground">
            {selectedCount} {t?.selected}
          </span>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={onMarkAsRead}
            className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition-opacity"
          >
            <Icon name="Check" size={16} />
            <span className="text-sm font-medium">{t?.markAsRead}</span>
          </button>

          <button
            onClick={onDelete}
            className="flex items-center gap-2 px-4 py-2 bg-destructive text-destructive-foreground rounded-lg hover:opacity-90 transition-opacity"
          >
            <Icon name="Trash2" size={16} />
            <span className="text-sm font-medium">{t?.delete}</span>
          </button>

          <button
            onClick={onCancel}
            className="flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors"
          >
            <Icon name="X" size={16} />
            <span className="text-sm font-medium">{t?.cancel}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsPanel;